import {Direction, Theme} from '@mui/material';

/* eslint-disable-next-line @nice-cxone/ccf/required-tsdoc */
const ccfEditorStyles = (theme: Theme) => {
  const styles = {
    editor: {
      minHeight: '70px',
      maxHeight: '70px',
      width: '100%',
      background: `${theme.palette.grey[100]} 0% 0% no-repeat padding-box`,       
      display: 'inline-block',
      opacity: '1',
      borderRadius: '4px',
      overflowY:'scroll',
      margin: '4px 12.5px',
      padding:  '16px 24.5px',
      wordBreak: 'break-word',
      fontSize: '.75rem',
    },
    editorFocus: {
      border: `2px solid ${theme.palette.background.dark}`, 
    },
    editorEmail: {
      maxHeight: 'max-content',
      background:'none',
    },
    outboundEmailEditor: {
      minHeight: '100%',
      background:'none',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      '@media only screen and (max-width: 1200px)': {
        minHeight: '80%',
      },
      position: 'relative',
      zIndex: '0',
    },
    toolbar: {
      display: 'block',
      width: '100%',
      borderBottom: 'none',
    },
    button: { 
      color: `${theme.palette.grey[800]}`,
      minWidth: '34px',
      '&:hover': {
        backgroundColor: `${theme.palette.action.hover}`,
      },
      padding: 0,
    },
    buttonActive: {
      background: theme?.palette?.background?.main,
      marginRight: '0.2rem',
    },
    replying: {
      margin: '2px 13.5px',
      font: 'normal normal normal 0.75rem/1rem Open Sans',
      letterSpacing: '0px',
      color: `${theme.palette.grey[800]}`,
      borderTop: `1px solid ${theme.palette.border.main}`,
    },
    wrapper: {
      font: 'normal normal normal 12px/17px Open Sans',
      color: '#000',
      'text-align': 'left',
      'letter-spacing': '0',
      display: 'flex',
      padding: '3px',
      paddingLeft: '15px',
    },
    styleLabel: {
      font: 'normal normal normal 12px/17px Open Sans',
      color: '#000',
      'text-align': 'left',
      'align-items': 'top',
      letterSpacing: '0',
      display: 'flex',
    },
    headerContainer: {
      background: `${theme.palette?.background?.callControlHeader} 0% 0% no-repeat padding-box`, // this vairable is used t
      border: `1px solid ${theme.palette.border?.main}`,
      borderRadius: '4px 4px 0px 0px',
      opacity: 1,
      height: '32px',
    },
    btnContainer: {
      'min-width': '34px !important', 
      padding: 0,
    },
    toolbox: {
      display: 'flex', 
      borderBottom: `1px solid ${theme.palette.border.main}`,
    },
    box: { 
      borderTop: 1, 
      borderColor: `${theme.palette.border.main}`,
      display:'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      backgroundColor: theme.palette.background.paper,
    },
    buttonBottom: { 
      bottom:'0',
      width: '100%',
      position: 'absolute',
    },
    rightSideBox: { 
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      marginTop: '8px',
      marginBottom: '8px',
    },
    leftSideBox:{
      justifyContent: 'flex-start',
      backgroundColor: theme.palette.background.paper,
      margin: '6px 4px',
    },
    toolboxContainer: {
      padding: '7px 0px',
    },
    floatRight: {
      float: 'right',
    },
    discard:{
      opacity: '1',
      borderRadius: '3px',
      border: `1px solid ${theme.palette.border?.main}`,
      boxShadow: `0px 1px 0px ${theme.palette.border?.main}`,
      padding:'0px',
      float:'right',
      color: `${theme.palette.grey[800]}`,
      margin:'5px 10px 9px 5px',
    },
    toContainer: {
      width: '100%',
      display: 'flex',
      borderBottom: '1px solid #D5DEE6',
      height: 'fit-content',
      borderTop: '1px solid #D5DEE6',
    },
    toLabel: {
      width: '85%',
    },
    bccContainer: {
      font: 'normal normal normal 12px/17px Open Sans',
      color: theme.palette.text.secondary,
      margin: 'auto',
      'font-weight': 600,
    },
    wrapperWithBorder: {
      font: 'normal normal normal 12px/17px Open Sans',
      color: '#000',
      'text-align': 'left',
      'letter-spacing': '0',
      display: 'flex',
      borderBottom: '1px solid #D5DEE6',
      padding: '3px',
      paddingLeft: '15px',
    },
    ccBox: {
      padding:'15% 10px 15% 0',
      cursor: 'pointer',
    },
    bccBox: {
      padding:'15% 0',
      cursor: 'pointer',
    },
    linked: {
      color: '#3b5998',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    linkBox: {
      width: '20vw',
      backgroundColor: '#f4f4f4',
      marginTop: '2px',
    },
    btnCheck: {
      verticalAlign: 'middle',
    },
    cancelButton:{
      margin: '0 0.75rem',
      float:'right',
      fontSize: `${theme?.typography?.h6?.fontSize}`,
      lineHeight: '1rem',
      letterSpacing: '0rem',
    },
    editorBox:{
      width: '100%',
      justifyContent:'space-between',
      display: 'flex',
      flexDirection:'row',
      alignItems:'stretch',
    },
    toolTipWidth:{
      width: '10%',
    },
    customerNameDisplay:{
      display: 'inline',
      paddingRight: '2px',
      width: '90%',
      paddingLeft: '1.5rem',
    },
    dragNDrop: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '1.25rem',
      borderWidth: '0.125rem',
      borderRadius: '0.125rem',
      borderColor: theme.palette.primary.light,
      borderStyle: 'dashed',
      outline: 'none',
      transition: 'border .24s ease -in -out',
      minHeight: '6.25rem',
      maxHeight: '6.25rem',
      background: 'none',
    },
    emailResponseWrapper: {
      display: 'flex',
      flexDirection: 'column',
      // overflowY: wysiwygEnabled ? 'scroll' : 'visible',
      overflowY: 'scroll'
    },
    publicReplyToBanner: {
      border: `solid ${theme?.palette?.border?.light}`,
      borderWidth: '0.063rem 0.063rem 0.063rem 0.313rem',
      borderRadius: '0.25rem',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      width:'fit-content',
      padding: '0.2rem 0.5rem',
      background: theme?.palette?.background?.lightYellow,
      marginLeft: '0.813rem',
    },
    publicReplyToBannerText: {
      fontSize: '0.625rem',
      color: theme?.palette?.secondary?.main,
    },
    publicReplyToBannerContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    line: {
      margin: '0.625rem', 
      border: `0.063rem solid ${theme?.palette?.border?.light}`,
    },
    responseDiv: {
      padding: '0.5rem',
      border: '0.063rem solid',
      borderRadius: '0.5rem',
      borderColor: theme?.palette?.text?.lightGrey,
      display: 'flex',
      alignItems: 'center',
      width:'100%',
      columnGap: '0.5rem',
      '&:hover': {
        backgroundColor: theme?.palette?.background?.noteInput,
        borderRadius: '0.5rem',
      },
    },
    responseText: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: theme?.palette?.background?.hoverDark,
      fontWeight: '600',
    },
    responseIcons: {
      display:'flex',
      marginLeft: 'auto',
      marginTop:'0.313rem',
      columnGap: '0.5rem',
    },
    icons:{
      '&:hover svg path': {
        fill: theme?.palette?.text?.noteLabel,
      },
    },
    newCarouselStyles: {
      mainCard: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '0.625rem',
        paddingBottom: '0.313rem',
      },
      responseText: {
        fontSize: '0.75rem',
        lineHeight: '1rem',
        color: theme?.palette?.text?.main,
        fontWeight: '600',
      },
      indicators: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0.25rem',
        minwidth: '3rem',
      },
      indicator: {
        height: '0.25rem',
        borderRadius: '50%',
        background: theme?.palette?.background?.darkGrey,
        cursor: 'pointer',
        border: 'none',
        display: 'block',
        minWidth: '0.25rem',
        padding: '0rem',
      },
      activeIndicator: {
        height: '0.25rem',
        borderRadius: '50%',
        cursor: 'pointer',
        border: 'none',
        display: 'block',
        minWidth: '0.25rem',
        background: theme?.palette?.text?.noteLabel,
        padding: '0rem',
      },
      card: {
        boxShadow: 'none',
        display:'flex',
        flexDirection:'column',
        width: '100%',
      },
      cardContent: {
        boxShadow: 'none',
        padding: '0rem',
        borderRadius: '1.5rem',
      },
      carouselDots: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height:'0.25rem',
        columnGap: '0.188rem',
        alignSelf: 'center',
        margin: '0.25rem',
      },
      iconsHover:{
        '&:hover svg path': {
          fill: theme?.palette?.text?.noteLabel,
        },
      },
    },
    nbrHoverStyle: {  
      borderRadius: '0.5rem',
      '&:hover': {
        backgroundColor: theme?.palette?.text?.noteLabel,
        borderRadius: '0.5rem',
      },
      '&:hover p, &:hover span, &:hover div': {
        color: theme?.palette?.text?.black,
      }, 
      '&:hover div': {
        backgroundColor: theme?.palette?.background?.noteInput,
      },
    },
    nullHover: {
      '&:hover': {
        background:'none',
      },
      padding:'0',
    },  
    sparklesIcon: {
      display: 'flex',
      marginLeft: 'auto',
      flexDirection: 'column',
    },
    nbrSparkle: {
      display: 'flex',
      marginLeft: '0.625rem',
      marginTop: '0.313rem',
      flexDirection: 'column',
      height: '1.25rem',
      width : '1.25rem',
    },
    timeStampTooltipArrow: {
      color: `${theme?.palette?.background?.paper}`,
    },
    timeStampTooltip: {
      backgroundColor: `${theme?.palette?.background?.paper}`,
      color: `${theme?.palette?.text?.black}`,
      boxShadow: '0px 4px 6px 0px rgba(0, 0, 0, 0.24)',
    },
  }
  return styles;
}
  
  export default ccfEditorStyles;